import { render, staticRenderFns } from "./cDocumentFullEditSection.vue?vue&type=template&id=32cd125e&scoped=true"
import script from "./cDocumentFullEditSection.vue?vue&type=script&lang=js"
export * from "./cDocumentFullEditSection.vue?vue&type=script&lang=js"
import style0 from "./cDocumentFullEditSection.vue?vue&type=style&index=0&id=32cd125e&prod&scoped=true&lang=scss"
import style1 from "./cDocumentFullEditSection.vue?vue&type=style&index=1&id=32cd125e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cd125e",
  null
  
)

export default component.exports